<template>
  <div>
    <b-card bg-variant="Default">
      <b-row class="match-height d-none d-lg-block">
        <b-col
          md="6"
          cols="10" 
          class="mb-2"
        >
          <!-- input search -->
          <b-input-group>
            <b-input-group-prepend>
              <b-form-select style="border-top-right-radius:0px; border-bottom-right-radius:0px;" v-model="campiRicerca.sezione" :options="options_ricerca" disabled-field="notEnabled"></b-form-select>
            </b-input-group-prepend>
              <b-form-input v-model="campiRicerca.nome"
                  placeholder="ricerca generale"
                  type="text" />
            <b-input-group-append>
              <b-button variant="outline-primary" @click.prevent="ricercaGenerale">
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>

          </b-input-group>
        </b-col>
        <b-col
          md="1" offset-md="5"
          cols="2"
          class="mb-2"
        >
          <b-button variant="outline-primary" class="px-0" @click.prevent="clickReset" block v-if="resetState != 'hidden'"><feather-icon icon="DeleteIcon" /></b-button>
        </b-col>
      </b-row>

        <!-- table -->
        <vue-good-table
        mode="remote"
        ref="table"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :rows="rows"
        :columns="columns"
        :isLoading=isLoading
        :search-options="{ 
            enabled: true,
            externalQuery: searchTerm }"
        :pagination-options="{
            enabled: true,
            perPage:pageLength
        }"
        >
        
        <template slot="loadingContent">
          <div class="text-center my-3">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem;"
                label="loading"
              />
              <div class="d-block pt-1 text-primary">Caricamento</div>
          </div>
        </template>
        
        <div slot="emptystate"> <div class="text-center py-4"> Nessun dato disponibile - (Messaggio personalizzabile) </div> </div>

        <template
            slot="table-row"
            slot-scope="props"
        >
            <!-- Column: stato -->
            <span v-if="props.column.field === 'stato'">
            <b-badge :variant="statusVariant(props.row.stato)">
              {{ props.row.stato }}
            </b-badge>
            </span>

            <span v-if="props.column.field === 'user.role'">
            <b-badge :variant="ruoloUser(props.row.user.role)">
              {{ props.row.user.role }}
            </b-badge>
            </span>
            
            <div v-else-if="props.column.field === 'user.surname'">
              <a @click="$router.push({ name: 'crm-utenti-show', params: { id_riga: props.row.id }})">{{ props.row.user.surname }}</a>  
            </div>

            <!-- Column: azioni -->
            <span v-else-if="props.column.field === 'azioni'">
              <div class="text-nowrap">
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="cursor-pointer text-secondary"
                  v-b-tooltip.hover.v-primary
                  title="Azioni"
                  :id="`tabellautenti-riga-${props.row.id}-sidebar-azioni`"
                  @click="sidebarAction(props.row.id, props.row.user.id, props.row.user.name+' '+props.row.user.surname, props.row.user.email, props.row.user.mobile_phone, props.row.user.phone, props.row.user.role, props.row.user.status)"
                />
              </div>
            </span>

            <!-- Column: standard -->
            <span v-else>
            {{ props.formattedRow[props.column.field] }}
            </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
            <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                Visualizzazione da 1 a 
                </span>
                <b-form-select
                v-model="pageLength"
                :options="['10','25','50','100']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap "> di {{ props.total }} righe </span>
            </div>
            <div>
                <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
                >
                <template #prev-text>
                    <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                    />
                </template>
                <template #next-text>
                    <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                    />
                </template>
                </b-pagination>
            </div>
            </div>
        </template>
        </vue-good-table>
            
    </b-card>

    <b-sidebar
      ref="sidebar_azioni"
      id="sidebar-right"
      bg-variant="white"
      :title="infoSideBar.titolo"
      right
      backdrop
      shadow
    >
      <div>
        <div class="py-0 px-2">
          
          <div class="divider">
              <div class="divider-text text-primary fw-bolder">DETTAGLI</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Email:</span> {{ infoSideBar.email }}
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Cellulare:</span> {{ infoSideBar.cellulare }}
            </b-col>
            <b-col>
              <span class="font-weight-bold spacer-dettagli">Ruolo:</span> <b-badge :variant="ruoloUser(infoSideBar.ruolo)">{{ infoSideBar.ruolo }}</b-badge>
            </b-col>
          </b-row>

          <div v-if="infoSideBar.stato == 'active'">
            <div class="divider">
              <div class="divider-text text-primary fw-bolder mt-2">AZIONI</div>
            </div>

            <b-row>
              <b-col xs="12" md="6">          
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary" block
                  class="mb-1"
                  @click="$router.push({ name: 'crm-utenti-show', params: { id_riga: infoSideBar.id }})"
                >
                  <feather-icon icon="EyeIcon" /> Visualizza
                </b-button>
              </b-col>
              <b-col xs="12" md="6">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning" block
                  class="mb-1"
                  @click="$router.push({ name: 'crm-utenti-edit', params: { id_riga: infoSideBar.id }})"
                >
                  <feather-icon icon="Edit2Icon" /> Modifica
                </b-button>
              </b-col>
              <b-col xs="12" md="6">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-danger" block
                  class="mb-1"
                  @click="cancellaRiga(infoSideBar.id)"
                >
                  <feather-icon icon="Trash2Icon" /> Cancella
                </b-button>
              </b-col>
              <b-col xs="12" md="6">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary" block
                  class="mb-1"
                  @click="$router.push({ name: 'crm-utenti-changepassword', params: { id_riga: infoSideBar.user_id, name: infoSideBar.titolo }})"
                >
                  <feather-icon icon="KeyIcon" /> Password
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <b-card border-variant="danger" class="mt-3">Non è possibile modificare un utente disattivato ...</b-card>
          </div>
        </div>

      </div>
    </b-sidebar>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BCardText, BRow, BCol, BBadge, BPagination, BSpinner, BFormGroup, BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BDropdownDivider, BFormSelect, BDropdown, BDropdownItem, BButton, BSidebar, VBToggle, VBTooltip
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BCard, 
    BCardText,
    BRow, 
    BCol, 
    BBadge,
    BPagination,
    BSpinner,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BDropdownDivider,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BButton,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      isLoading: true,
      emptystate: true,
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Cognome',
          field: 'user.surname',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          }
        },
        {
          label: 'Nome',
          field: 'user.name',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          }
        },
        {
          label: 'Cellulare',
          field: 'user.mobile_phone',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
          //thClass: 'd-none d-lg-table-cell',
          //tdClass: 'd-none d-lg-table-cell',
        },
        {
          label: 'Email',
          field: 'user.email',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Ruolo',
          field: 'user.role',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra', 
            filterDropdownItems: [],          
          },
        },
        {
          label: '',
          field: 'azioni',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
      rows: [],
      searchTerm: '',
      resetState: 'hidden',
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      startServerParams: {
        columnFilters: {
        },
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      options_ricerca: [
        { value: null, text: 'seleziona...' },
        { value: 'user.name', text: 'Nome' },
        { value: 'user.surname', text: 'Cognome' },
        { value: 'user.email', text: 'Email' },
        { value: 'user.mobile_phone', text: 'Cellulare' },
        { value: 'user.role.display_name', text: 'Ruolo' },
        /* 
        { value: 'billing.region.name', text: 'Regione' },
        { value: 'billing.province.name', text: 'Provincia' },
        { value: 'colonna_inesistete', text: 'Colonna Errore' },
        { value: 'mobile_phone', text: 'Cellulare', notEnabled: true, disabled: true },
        {
          label: 'Raggruppamento',
          options: [
            { value: 'altro_1', text: 'Altro 1 (non usare)' },
            { value: 'altro_2', text: 'Altro 2 (non usare)' }
          ]
        }
        */
      ],
      campiRicerca: {
        nome: '',
        sezione: null,
      },
      infoSideBar: {
        id: '',
        user_id: '',
        fullName: '',
        email: '',
        mobile_phone: '',
        phone: '',
        role: '',
        status: ''
      }
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Attivo : 'light-success',
        Disattivo : 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    
    ruoloUser() {
      const ruoloColor = {
        /* eslint-disable key-spacing */
        'SuperAdmin' : 'light-success',
        'Admin' : 'light-info',
        'Venditore' : 'light-warning',
        'Assistente' : 'light-secondary',
        'Cliente' : 'light-danger',
        'Vip' : 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => ruoloColor[status]
    },
  },
  mounted() {
    //in caso di resize del browser -> ricalcolo della larghezza della finestra
    window.onresize = () => {
      this.checkWindowsSizeAndResponsiveGoodTable();
    }
  },
  created() {
    this.checkWindowsSizeAndResponsiveGoodTable();

    this.loadItems();
  },
  methods: {
    checkWindowsSizeAndResponsiveGoodTable(){
      this.windowWidth = window.innerWidth

      if(window.innerWidth <768){
        this.$set(this.columns[2], 'hidden', true)
        this.$set(this.columns[3], 'hidden', true)
        this.$set(this.columns[4], 'hidden', true)
      } else if(window.innerWidth <1000){
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', true)
      } else if(window.innerWidth <1200){
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
      } else {
        //tutte le colonne visualizzate
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
      }
    },
    ricercaGenerale(){
      console.log("ricerca generale - chiamata Api per avere la ricerca su tutti i dati e NON solo sui dati dell'attuale viewport della tabella ;-)")
      console.log(this.campiRicerca)

      if((this.campiRicerca.sezione !== null) && (this.campiRicerca.sezione !== 'undefined')){
        console.log("ok ricerca valida")

        //aggiorna parametri con la stessa funzione del filtro colonna ;-)
        this.updateParams({
          columnFilters: {
            [this.campiRicerca.sezione]: this.campiRicerca.nome
          },
        });

        //forza reset filtro colonne
        this.$refs.table.reset();

        this.loadItems();

        //attiva bottone "reset"
        this.resetState = 'attiva';
      }
    },
    clickReset(){
      console.log("clickReset");

      //forza reset filtro colonne
      this.$refs.table.reset();

      //forza reset parametri iniziali della tabella
      /*
      console.log("PRIMA ----")
      console.log(this.serverParams)
      this.serverParams = this.startServerParams;
      console.log("DOPO ----")
      console.log(this.serverParams)
      */
      this.updateParams(this.startServerParams);
      this.loadItems();

      //reset campi ricerca
      this.campiRicerca.nome = '';
      this.campiRicerca.sezione = null;
      //disattiva bottone "reset"
      this.resetState = 'hidden';
    },
    advanceFilter(val) {
      //this.searchTerm = val

      this.updateParams(val);
      this.loadItems();
    },
    sidebarAction(id, user_id, titolo, email, mobile_phone, phone, role, status) {
      this.infoSideBar = { 
        id: id,
        user_id: user_id,
        titolo: titolo,
        email: email,
        cellulare: mobile_phone,
        fisso: phone,
        ruolo: role,
        stato: status
      };

      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    
    updateParams(newProps) {
      console.log(newProps)

      if (typeof newProps.columnFilters !== 'undefined'){
        //if(typeof newProps.columnFilters.user.role !== 'undefined')
        //typeof props.row.user === 'object' && props.row.user !== null
        if((typeof newProps.columnFilters["user.role"] !== 'undefined')){
          console.log("qui...")
          console.log(newProps.columnFilters["user.role"])

          //in caso di campo con "stringa" => vai di filtro per il valore richiesto
          if(newProps.columnFilters["user.role"] != ''){
            newProps.columnFilters["user.role_id"] = newProps.columnFilters["user.role"];
          }

          //in caso di campo in cui avevo impostato un filtro e lo voglio cancellare
          if(newProps.columnFilters["user.role"] == ''){
            delete(newProps.columnFilters["user.role_id"]);
          }
        }

      }

      //attiva bottone "reset" filtro o ricerca
      this.resetState = 'attiva';

      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      console.log('cambio ordinamento')
      console.log(params)

      let field_ricerca = '';

      //colonne con relazione
      if(params[0].field == 'user.role'){
        field_ricerca = 'user.role_id';
      } else {
        field_ricerca = params[0].field;
      }

      this.updateParams({
        sort: [{
          type: params[0].type,
          field: field_ricerca,
        }],
      });
      this.loadItems();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    loadItems() {
      this.isLoading = true;

      //console.dir(this.serverParams)

      if (typeof this.serverParams.columnFilters['user.role_id'] !== 'undefined'){
        delete(this.serverParams.columnFilters["user.role"]);
      }

      this.$http.get('api/crm/employee/list', {
        params: this.serverParams 
        }).then(response => { 
            /*
            console.log("risposta vvv"); 
            console.log(response.data)
            console.log('--- ---')
            console.dir(response.data.reply.data)
            console.log("response.data.reply.meta.total -> "+response.data.reply.meta.total);
            */
            
            if(response.data.statusCode == 200){
              //ok

              //popolazione select filtro "Ruolo"
              if(this.columns[4].filterOptions.filterDropdownItems[0] === undefined){
                this.columns[4].filterOptions.filterDropdownItems = response.data.reply.data[0].user.frontendSelects.role
              }

              this.totalRecords = response.data.reply.meta.total;
              this.rows = response.data.reply.data;

            } else if(response.data.statusCode == 422){
              //errori con testo di notifica ok dall'api
              alert("messaggio -> "+response.data.reply)
              this.$swal({
                title: 'Errore',
                text: 'codice errore: '+response.data.reply,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
            } else {
              //tutto gli altri possibili errori
              this.$swal({
                title: 'Errore Generico',
                text: 'codice errore: '+response.data.statusCode,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
            }
            
            //rimuovi il loading dopo il caricamento dei dati nella tabella
            this.isLoading = false;
        
        })

    },
    cancellaRiga(id_riga){
      console.log("click cancellaRiga ...... id_riga -> "+id_riga);

      this.$swal({
        title: 'Sei sicuro di voler procedere?',
        html: "conferma la cancellazione definitiva dell'utente?<br><br><i>nota:</i>: i lead e/o i clienti assegnati a questo utente saranno assegnati agli utenti principali definiti nelle impostazioni",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'SI, Procedi',
        cancelButtonText: 'Annulla operazione',
        customClass: {
          confirmButton: 'btn btn-outline-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

            this.$http.post('api/crm/employee/reassign_default_users/'+id_riga)
            .then(response => { 
                //console.log("risposta server --------")
                console.log(response.data)

                if((response.data.statusCode===200) && (response.data.reply.risposta == 'Riassegnazione effettuata con successo')){
                  //risposta positiva -> adesso che siamo sicuri che l'utente non ha nulla a cui è collegato lo cancelliamo definitivamente
                  this.$http.post('api/crm/employee/delete/'+id_riga)
                  .then(response => { 
                      //console.log("risposta server --------")
                      //console.log(response.data)

                      if(response.data.statusCode===200){
                        //risposta positiva
                        this.$swal({
                            icon: 'success',
                            title: response.data.reply.reply,
                            //text: 'operazione effettuata correttamente',
                            confirmButtonText: 'chiudi',
                            customClass: {
                            confirmButton: 'btn btn-success',
                            },
                        })

                        //chiudi sidebar
                        this.$refs.sidebar_azioni.hide();

                        //aggiorna tabella
                        this.loadItems();
                          
                      } else {
                      //risposta negativa (errore sul server)
                        this.$swal({
                            icon: 'error',
                            title: 'Si è verificato un errore',
                            text: response.data.reply.message,
                            customClass: {
                            confirmButton: 'btn btn-outline-primary',
                            },
                        })
                      }
                  }).catch(e => {
                      console.log(e);
                  })
                  
                    
                } else {
                //risposta negativa (errore sul server)
                  this.$swal({
                      icon: 'error',
                      title: 'Si è verificato un errore nella riassegnazione dei lead, clienti è attività',
                      text: response.data.reply.message,
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                }
            }).catch(e => {
                console.log(e);
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.riga_sidebar{
  padding-bottom: 5px;
}

.spacer-dettagli{
  width: 90px;
  display: inline-block;
}
</style>